import api from '../lib/api'
import assign from 'lodash.assign'

const name = 'exchange'

export default {
  name,
  namespaced: true,
  state () {
    return {
      prizeList: [],
      exchangeDate: '',
      exchangeName: '',
      errorCode: 0,
      type: 8
    }
  },
  getters: {},
  mutations: {
    set (state, data) {
      assign(state, data)
    }
  },
  actions: {
    async submitCode ({ commit }, { code, showNotice}) {
      const { data, code:errorCode } = await api.exchange.push(code)()
      if (data) {
        commit('set', {
          exchangeDate: data.exchangeDate,
          exchangeName: data.exchangeName,
          type: parseInt(data.type),
          errorCode: 0
        })
        showNotice()
      }
      commit('set', { errorCode })
    },
    async getList ({ commit }) {
      const { data:prizeList } = await api.exchange.getList()
      commit('set', { prizeList })
    }
  }
}
